<template lang="pug">
  v-flex.dropbox
    form.form-dropbox(
    enctype="multipart/form-data"
    novalidate
    )
      v-layout.message(
        column
        wrap
        align-center
        justify-center
        fill-height
      )
        v-flex(shrink v-if="!fileLoadSuccess")
          v-icon.upload-icon.mb-2 cloud_upload
          v-flex
            slot(name="title")
              span Drag your file here
            span.file-upload-limit(v-if="!hideFileLimit") ({{maxSizeInMB}}MB max)
          slot(v-if="!hideSubtitle" name="subtitle")
            p.font-weight-bold or click to browse
        v-flex(shrink v-else)
          v-icon.upload-icon.primary--text cloud_done
          p.primary--text {{ fileName }}
          v-btn.v-btn--flat.theme--light.text-none.mt-3.remove-btn(
              @click="removeFile"
          )
            | Click to remove
        input.input-dropbox(
          type="file"
          :accept="getAllowedFileExtensions"
          @change="handleFile"
          v-show="!fileLoadSuccess"
        )
</template>

<script>
export default {
  name: 'FileDropzone',
  props: {
    maxSizeInMB: {
      type: Number,
      default: 10,
    },
    allowedFileExtensions: {
      type: Array,
      default: [],
    },
    readAsType: {
      type: String,
      default: 'dataURL',
    },
    file: {
      type: File,
      default: null,
    },
    hideFileLimit: {
      type: Boolean,
    },
    hideSubtitle: {
      type: Boolean,
    },
  },
  computed: {
    getAllowedFileExtensions() {
      return this.allowedFileExtensions.map(extension => `.${extension}`).join(',');
    },
  },
  data() {
    return {
      fileLoadSuccess: false,
      fileName: '',
    };
  },
  watch: {
    file() {
      this.fileName = this.file ? this.file.name : '';
      this.fileLoadSuccess = !!this.file;
    },
  },
  methods: {
    handleFile({ target }) {
      const file = target.files;
      if (file.length < 1) {
        console.error('No file selected');
        return;
      }

      const firstFile = file[0];
      const allowedFileExtension = this.allowedFileExtensions.find(fileExtension =>
        firstFile.name.match(`.${fileExtension}`));
      if (!allowedFileExtension) {
        console.error(`Please select a file with an allowed file extension such as ${this.allowedFileExtensions.join(', ')}`, firstFile);
        return;
      }

      const fileSizeInMB = firstFile.size / 1024 ** 2;
      if (fileSizeInMB > this.maxSizeInMB) {
        console.error(`Please select a file below ${this.maxSizeInMB} MB`);
        return;
      }

      this.$emit('loadRawFile', firstFile);
      const reader = new FileReader();
      reader.onload = result => {
        this.$emit('readFile', result);
      };
      if (this.readAsType === 'text') {
        reader.readAsText(firstFile);
      } else {
        reader.readAsDataURL(firstFile);
      }
      target.value = '';
    },
    removeFile() {
      this.$emit('removeFile');
    },
  },
};
</script>

<style lang="scss" scoped>
.dropbox {
  position: relative;
  outline: 2px dashed var(--v-secondary-lighten3);
  padding: 20px;
  background-color: white;

  .form-dropbox {
    height: 100%;

    .input-dropbox {
      opacity: 0;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      right: 0;
      cursor: pointer;
    }

    .message {
      text-align: center;
      color: var(accent-color);
      font-size: 20px;

      .upload-icon {
        font-size: 4em;
      }

      p {
        margin-bottom: 0;
      }
      .file-upload-limit{
        margin-left: 4px;
      }
      .remove-btn {
        font-size: 20px;
        color: var(accent-color);
      }
    }
  }
}
</style>